import React from 'react';
import {Divider} from 'antd';
import ReactMarkdown from 'react-markdown'

import '../styles/CVBlock.less';


class CVBlock extends React.Component {
  renderContent = (content, ordered) => {
    if (typeof content === 'string'){
      content = content.replace(/\n/g, '\n\n').replace(/^\s+|^\s+$/g, '');
      return <ReactMarkdown source={content} escapeHtml={false} />;
      // return <p>{content}</p>;
    }
    if (content instanceof Array){
      const listItems = content.map(item => <li key={item}>{this.renderContent(item)}</li>);
      if (ordered) {
        return <ol>{listItems}</ol>;
      }
      return <ul>{listItems}</ul>
    }
    return content;
  };

  render() {
    const { title, content, ordered } = this.props;

    return (
      <div className="cv-block">
        <h2>{title}</h2>
        <Divider />
        <div className="cv-block-content">
          {this.renderContent(content, ordered)}
        </div>
      </div>
    );
  }
}

export default CVBlock;